import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ResolveTranslateAbleTextPipe, type TranslateAbleText } from '@pct-ng/i18n';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pct-form-button-row',
  imports: [MatButton, ResolveTranslateAbleTextPipe, RouterLink],
  templateUrl: './button-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col md:flex-row md:justify-end gap-4 w-full',
  },
})
export class ButtonRowComponent {
  readonly formId = input.required<string>();
  readonly disableBackButton = input(false, { transform: booleanAttribute });
  readonly disableSubmitButton = input.required({ transform: booleanAttribute });
  readonly backButtonLabel = input<TranslateAbleText>('COMMON.BACK');
  readonly submitButtonLabel = input<TranslateAbleText>('COMMON.SAVE');
  readonly backButtonRouterLink = input<string>();
  readonly clickBackButton = output<MouseEvent>();
}
